<template>
    <ModalComponent
        :name="name"
        :title="title"
        v-on:close="() => close(false)"
        v-if="!loading"
    >
        <Form
            :data="grupo"
            @terminado="editar()"
        />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import Form from '@/components/backend/abonos/precios/grupos/Form.vue';

    export default {
        props: {
            name: String,
            title: String,
            grupo: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            close() {                
                this.$emit('close', 'edit-modal-' + this.grupo.id);
            },
            editar() {
                if (! this.loading) {
                    this.loading = true;

                    this.grupo.filters = {};
                    this.grupo.lista_id = this.$store.getters.getListaId;
                    this.grupo.grupo_id = this.grupo.id;

                    this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.editar'), this.grupo).then(res => {
                        this.$modal.hide('edit-modal-' + this.grupo.id);
                        this.$emit('editado');
                        this.loading = false;
                        this.grupo = {};
                    });
                }
            }
        },
        components: {
            ModalComponent, Form
        }
    }
</script>